<template>

  <modalo
    :title="$t('Export')"
    type="mini"
    @hideModal="hideModal()">

    <form
      :class="{'box-loading': loading}"
      v-on:submit.prevent="exportFile">
      <div class="form-group">
        <label>{{ $t('Period') }}</label>
        <RangeDate
          v-model="value.range_date"
          style="min-width: 210px" />
      </div>
      <div class="form-group">
        <label>{{ $t('Entity') }}</label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="radio-candidate"
            value="candidate"
            v-model="value.entity">
          <label
            class="form-check-label"
            for="radio-candidate">
            {{ $t('Candidate') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="radio-candidate-hired"
            value="candidate-hired"
            v-model="value.entity">
          <label
            class="form-check-label"
            for="radio-candidate-hired">
            {{ $t('Hireds') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="radio-job-detail"
            value="job-detail"
            v-model="value.entity">
          <label
            class="form-check-label"
            for="radio-job-detail">
            {{ $t('Job details') }}
          </label>
        </div>
        <!--<div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="radio-job-pipeline"
            value="job-pipeline"
            v-model="value.entity">
          <label
            class="form-check-label"
            for="radio-job-pipeline">
            {{ $t('Current pipeline') }}
          </label>
        </div>-->
      </div>
      <div class="form-group">
        <label>{{ $t('File type') }}</label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="radio-csv"
            value="csv"
            v-model="value.file_type">
          <label
            class="form-check-label"
            for="radio-csv">
            CSV
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="radio-xlsx"
            value="xlsx"
            v-model="value.file_type">
          <label
            class="form-check-label"
            for="radio-xlsx">
            Excel
          </label>
        </div>
      </div>
      <button
        type="submit"
        class="btn btn-primary">Exportar</button>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import RangeDate from '@/components/Fields/RangeDate'

export default {
  name: 'DataimexModalExport',
  components: {
    RangeDate
  },
  props: [
  ],
  data () {
    return {
      loading: false,
      value: {
        entity: 'candidate',
        file_type: 'csv',
        range_date: null
      }
    }
  },
  created () {
  },
  methods: {
    hideModal () {
      this.$emit('hideModal')
    },
    exportFile () {
      this.loading = true

      this.$store
      .dispatch('exportDataimex', {
        entity: this.value.entity,
        file_type: this.value.file_type,
        start_at: this.value.range_date ? this.value.range_date[0] : null,
        end_at: this.value.range_date ? this.value.range_date[1] : null
      })
      .then(() => {
        this.$emit('saved')
      }).catch((err) => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dataimex/DataimexModalExport.vue